/** проверяем, что дата валидна и не содержит NaN */
export const isValidDate = (value: Date | null | undefined): value is Date => {
	return !!value && !Number.isNaN(value.getTime());
};

/** возвращаем текущую дату без времени */
export const getToday = (): Date => {
	const now = new Date();
	return new Date(
		now.getFullYear(),
		now.getMonth(),
		now.getDate(),
		0,
		0,
		0,
		0,
	);
};
